import { createSvgIcon, SvgIconProps } from '@chronosphereio/chrono-ui';

const IconBase = createSvgIcon(
  <svg viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="15" y="20.2461" width="3" height="8" className="bar-fill" fill="currentColor" />
    <rect x="9" y="16.2461" width="3" height="12" className="bar-fill" fill="currentColor" />
    <rect x="21" y="14.2461" width="3" height="14" className="bar-fill" fill="currentColor" />
    <rect x="27" y="10.2461" width="3" height="18" className="bar-fill" fill="currentColor" />
    <rect x="3" y="20.2461" width="3" height="8" className="bar-fill" fill="currentColor" />
    <path
      d="M3.5 17.7461L10.7222 13.2461L16.5 15.2461L29.5 5.24609"
      className="line-stroke"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>,
  'TimeSeriesChartIcon'
);

export const TimeSeriesChartIcon = (props: SvgIconProps) => {
  return (
    <IconBase
      {...props}
      sx={(theme) => ({
        '.bar-fill': {
          color: theme.palette.status.success.main,
        },
        '.line-stroke': {
          stroke: theme.palette.status.success.highContrast,
        },
      })}
    />
  );
};
